var _  = require('lodash');
var Rx = require('ub_wrapped/rx');

var Dialogs = {
  readyToRepublish : require('./ready_to_republish'),
  publishing       : require('./publishing'),
  publishSuccess   : require('./publish_success'),
  publishError     : require('./publish_error')
};

var dialogNameMap = {
  readyToRepublish   : 'readyToRepublish', // from editor UI

  requestRepublish   : 'publishing', // from editor UI
  republishInitiated : 'publishing',
  publishing         : 'publishing',
  republishing       : 'publishing',

  publishSuccess     : 'publishSuccess',
  republishSuccess   : 'publishSuccess',

  publishError       : 'publishError',
  republishError     : 'publishError'
};

var statesFromEditorUI = ['readyToRepublish', 'requestRepublish'];

var _isDialogState = function(type) {
  return _.has(dialogNameMap, type);
};


var PublishDialogs = function(editorUIBinding, pagePublishObs) {
  this._editorUIBinding = editorUIBinding;
  this._currentDialog = null;
  this._currentDialogName = null;

  var self = this;

  // Subscribe to publish and UI events and trigger corresponding dialog
  Rx.Observable.merge(
    editorUIBinding.source.filter(
      function(ev) {return _.contains(statesFromEditorUI, ev.type);}),
    pagePublishObs)
  .ub_subscribe(function(ev) {
    if (_isDialogState(ev.type)) {
      self.showDialog(ev.type);
    } else if (self._currentDialogName === 'publishing') {
      // The user has no way of closing this dialogue and it should
      // only be shown during publishing. If we see a state that
      // doesn't match a dialog close it.
      self.forceCloseDialogue();
    }
  });
};

PublishDialogs.prototype.showDialog = function(eventType) {
  var dialogName = dialogNameMap[eventType];

  if ( ! dialogName) {
    throw new Error('Invalid dialog: ' + eventType);
  }

  var mainPage = window.editor.mainPage;

  var dialog = new Dialogs[dialogName]({
    editorUIBinding : this._editorUIBinding,
    mainPage        : mainPage,
    pageTitle       : mainPage.page.title || window.gon.page_title,
    eventType       : eventType,
    contentType     : mainPage.getConfigValue('displayName'),
    showUrl         : mainPage.getConfigValue('showPublishedURL')
  });

  dialog.e.addClassName('modal-panel-republish-dialog');
  dialog.addListener('closed', this._clearState.bind(this));

  if (this._currentDialog) {
    this._currentDialog.hide();
  }

  // Opens the dialog through the dialog manager, which ensures multiple dialogs aren't
  // open at the same time, which isn't supported and leads to errors
  if (window.editor.dialogManager) {
    window.editor.dialogManager.openDialog(dialog);
  } else{
    dialog.open();
  }
  this._currentDialog = dialog;
  this._currentDialogName = dialogName;
};


PublishDialogs.prototype._clearState = function() {
  this._currentDialog = null;
  this._currentDialogName = null;
};


PublishDialogs.prototype.forceCloseDialogue = function() {
  if (this._currentDialog) {
    this._currentDialog.close();
  }
  this._clearState();
};

module.exports = PublishDialogs;



// WEBPACK FOOTER //
// ./src/lp/editor/dialogs/publish/index.js